/**
 * Site Search
 */

class SiteSearch {
	constructor(form) {
		if (typeof form === 'undefined' || form === null) {
			return;
		}

		this.form = form;
		this.formTextField = this.form.querySelector('input[type="text"]');
		this.logo = document.getElementsByClassName('custom-logo-wrapper');
		this.showFormHandler = this.showFormHandler.bind(this);
		this.hideFormHandler = this.hideFormHandler.bind(this);
		this.setDisplay();
	}

	/**
	 * Method to add styles to display search form field in the header.
	 */
	showFormHandler() {
		const { form, formTextField } = this;
		const isVisible = !!form.classList.contains('active');
		const ie = document.querySelectorAll('.ie');

		if (!isVisible) {
			form.classList.add('active');
			this.hideLogo();
			formTextField.focus();
			if (!ie.length) {
				formTextField.placeholder = 'Enter search term here...';

				/** Removes and adds event listeners needed for functioning */
				form.removeEventListener('click', this.showFormHandler, false);
			}
			form.addEventListener('blur', this.hideFormHandler, false);
		} else if (ie.length) {
			formTextField.focus();
		}
		return false;
	}

	/**
	 * Method to restore menu and search form to it's original state.
	 */
	hideFormHandler() {
		const { form, formTextField } = this;
		const isVisible = !!form.classList.contains('active');

		if (isVisible) {
			form.classList.remove('active');
			this.showLogo();
			formTextField.placeholder = 'Search';

			/** Removes and adds event listeners needed for functioning */
			form.removeEventListener('blur', this.hideFormHandler, false);
			form.addEventListener('click', this.showFormHandler, false);
			formTextField.value = '';
		}
	}

	hideLogo() {
		const { form } = this;
		if (form.closest('header') !== null && this.logo.length) {
			const logo = this.logo[0];
			if (!logo.classList.contains('active')) {
				logo.classList.add('active');
			}
		}
	}

	showLogo() {
		const { form } = this;
		if (form.closest('header') !== null && this.logo.length) {
			const logo = this.logo[0];
			if (logo.classList.contains('active')) {
				logo.classList.remove('active');
			}
		}
	}

	/**
	 * Core me
to set display of search method.
	 */
	setDisplay() {
		const { form } = this;
		form.addEventListener('click', this.showFormHandler, false);

		document.addEventListener('click', (e) => {
			if (!e.target.closest('.search-form.active')) {
				this.hideFormHandler();
			}
		}, false);
		return true;
	}
}

const siteMenuSearch = {
	init() {
		const searchForm = [
			document.querySelector('.site-menu__search form'),
			document.querySelector('.site-header__search form'),
		];

		if (searchForm.length) {
			searchForm.map((form) => new SiteSearch(form));
		}
	},
};

siteMenuSearch.init();
